exports.components = {
  "component---src-components-index-js": () => import("./../../../src/components/index.js" /* webpackChunkName: "component---src-components-index-js" */),
  "component---src-pages-checkout-js": () => import("./../../../src/pages/checkout.js" /* webpackChunkName: "component---src-pages-checkout-js" */),
  "component---src-pages-pay-js": () => import("./../../../src/pages/pay.js" /* webpackChunkName: "component---src-pages-pay-js" */),
  "component---src-pages-preview-js": () => import("./../../../src/pages/preview.js" /* webpackChunkName: "component---src-pages-preview-js" */),
  "component---src-pages-section-jsx": () => import("./../../../src/pages/section.jsx" /* webpackChunkName: "component---src-pages-section-jsx" */),
  "component---template-js": () => import("./../../../template.js" /* webpackChunkName: "component---template-js" */)
}

